import { Injectable } from '@angular/core'
import { SocketStockEvEnum } from '@modules/prices-module/socket-prices/enums/socket-stock-ev.enum'
import { SocketStocksType } from '@modules/prices-module/socket-prices/types/socket-stocks.type'
import { SocketStocksResponseType } from '@modules/prices-module/socket-prices/types/socket-stocks-response.type'

@Injectable({
	providedIn: 'root',
})
export class SocketPricesHelperService {
	protected readonly socketStockEvEnum: typeof SocketStockEvEnum = SocketStockEvEnum

	public getStockByEV(
		ev: SocketStockEvEnum,
		stocks: SocketStocksType[] | undefined,
		ticker?: string,
	): SocketStocksType | undefined {
		if (!stocks) return

		return stocks.find((stock: SocketStocksType): boolean => {
			if (ticker) {
				return stock.ev === ev && stock.sym === ticker
			}

			return stock.ev === ev
		})
	}

	public formatSocketStocks(stocks: SocketStocksResponseType[]): SocketStocksType[] {
		return stocks.map((stock: SocketStocksResponseType): SocketStocksType => {
			if (stock.ev === this.socketStockEvEnum.Q) {
				return {
					...stock,
					ap: Number(stock.ap),
					as: Number(stock.as),
					ax: Number(stock.ax),
					bp: Number(stock.bp),
					bs: Number(stock.bs),
					bx: Number(stock.bx),
					i: Number(stock.i),
					q: Number(stock.q),
					z: Number(stock.z),
					t: Number(stock.z),
				}
			}
			if (stock.ev === this.socketStockEvEnum.A) {
				return {
					...stock,
					a: Number(stock.a),
					av: Number(stock.av),
					c: Number(stock.c),
					h: Number(stock.h),
					l: Number(stock.l),
					o: Number(stock.o),
					v: Number(stock.v),
					vw: Number(stock.vw),
					z: Number(stock.z),
					op: Number(stock?.op),
				}
			}
			if (stock.ev === this.socketStockEvEnum.T) {
				return {
					...stock,
					c: stock.c,
					p: Number(stock.p),
					q: Number(stock.q),
					s: Number(stock.s),
					t: Number(stock.t),
					x: Number(stock.x),
				}
			}
			return stock
		})
	}
}
